import script from "./CurrencyView.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrencyView.vue?vue&type=script&setup=true&lang=js"

import "./CurrencyView.vue?vue&type=style&index=0&id=cfd1d0c4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfd1d0c4"]])

export default __exports__